module.exports = __webpack_public_path__ + "static/img/bg-pt.f0e92d9b.png";